import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLanguage } from '../../slices/languageSlice';
import { useSelector } from 'react-redux';

const AppLandingPage = (props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { userDetails, token } = useSelector((state) => state.user);
	const { language } = useSelector((state) => state.language);
	useEffect(() => {
		console.log('AppLandingPage Entry')
		// setLanguageFn();
	}, [])

	const setLanguageFn = () => {
		// dispatch(setLanguage(language || 'en'));
		console.log("userDetails=======", userDetails)
		console.log("token=======", token)
		if (userDetails && Object.keys(userDetails).length > 0 && token && token !== "") {
			navigate(`/${language || 'en'}/dashboard`);
		} else {
			navigate(`/${language || 'en'}/login`);
		}
	}

	return (
		<></>
	);
}

export default AppLandingPage;


